// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".quote-price-container[data-v-f44ca972]{align-items:center;display:flex;justify-content:center}.price-focused[data-v-f44ca972]{color:#3e4cd4;font-size:30px;font-weight:500}.price-focused span[data-v-f44ca972]{font-size:15px}@media print,screen and (min-width:769px){.price-focused[data-v-f44ca972]{font-size:35px}.price-focused span[data-v-f44ca972]{font-size:18px}}.small-price[data-v-f44ca972]{font-size:12px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
